<template>
  <v-container>
    <btn-a class="ma-2" outlined rounded color="primary" @click="calendarExcDialogOpen">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-list two-line subheader v-if="value.calendarExcs">
      <div v-for="(item,i) in value.calendarExcs" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ item.date | dateFilter }}</v-list-item-title>
            <v-list-item-subtitle>{{ `${item.start} / ${item.end}` }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="calendarExcDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="calendarExcRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="value.calendarExcs && value.calendarExcs.length"></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="calendarExcDialog"
      title="Calendar Exc"
      @confirm="calendarExcConfirm"
      @cancel="calendarExcDialogCancel"
    >
      <calendarExcForm ref="form" v-model="calendarExcSelected" />
    </dialog-d>
  </v-container>
</template>


<script>
import moment from "moment";
import calendarExcForm from "../environments/calendarExcForm";
export default {
  components: { calendarExcForm },
  props: {
    value: {
      default: () => {
        return {
          description: "",
          jobStageStatus: [],
          jobStatus: [],
          calendarProds: [],
          calendarExcs: []
        };
      }
    }
  },
  filters: {
    dateFilter(value) {
      return moment(value).format("DD/MM/YY");
    }
  },
  data() {
    return {
      dayOfWeeks: [
        { key: 0, value: "Sunday" },
        { key: 1, value: "Monday" },
        { key: 2, value: "Tuesday" },
        { key: 3, value: "Wednesday" },
        { key: 4, value: "Thursday" },
        { key: 5, value: "Friday" },
        { key: 6, value: "Saturday" }
      ],
      calendarExcSelected: {},
      calendarExcSelectedRef: null
    };
  },
  computed: {
    calendarExcComp() {
      let calendarExc = [];
      this.value.calendarExcs.forEach(js => {
        if (js.status != this.calendarExcSelected.status)
          calendarExc.push(js.status);
      });
      return calendarExc;
    }
  },
  methods: {
    calendarExcDialogCancel() {
      this.calendarExcSelectedRef = null;
    },
    calendarExcConfirm() {
      if(!this.$refs.form.isValid()) return;
      if (this.calendarExcSelectedRef != null) {
        Object.assign(this.calendarExcSelectedRef, this.calendarExcSelected);
      } else {
        this.value.calendarExcs.push(this.calendarExcSelected);
      }
      this.$refs.calendarExcDialog.open();
      this.calendarExcSelectedRef = null;
    },
    calendarExcRemove(calendarExc) {
      let index = this.value.calendarExcs.indexOf(calendarExc);
      if (index >= 0) this.value.calendarExcs.splice(index, 1);
    },
    calendarExcDialogOpen(calendarExc) {
      if (calendarExc) {
        this.calendarExcSelectedRef = calendarExc;
        let obj = {};
        Object.assign(obj, calendarExc);
        this.calendarExcSelected = obj;
      } else {
        this.calendarExcSelected = {};
      }

      this.$refs.calendarExcDialog.open();
    }
  }
};
</script>